import React from 'react';
import PropTypes from 'prop-types';
import { useTableTwoColumns } from '../hooks/useTableColumns';
import BaseTable from '../../../components/BaseTable/BaseTable';

const TableTwo = ({ data, isLoading, error, subBranchDashboard, showNoStoreSelected = false }) => {
  const columns = useTableTwoColumns({ subBranchDashboard });

  return (
    <BaseTable
      data={data}
      columns={columns}
      isLoading={isLoading}
      error={error}
      showNoStoreSelected={showNoStoreSelected}
    />
  );
};

TableTwo.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  isLoading: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.bool]),
  subBranchDashboard: PropTypes.bool,
  showNoStoreSelected: PropTypes.bool,
};

export default React.memo(TableTwo);
